import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { components } from 'react-select';

function DropdownIndicator (props) {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <FontAwesomeIcon color={props?.color ?? 'primary'} size="xl" icon={props.selectProps.menuIsOpen ? faCaretUp : faCaretDown} />
            </components.DropdownIndicator>
        )
    );
};

export default DropdownIndicator